import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Row } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import Select from 'react-select';
import { renderMaskedField } from '@/shared/components/form/FormField';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { Button } from '@/shared/components/Button';
import { AuthContext } from '../../../../context/AuthContext';

const PrimaryContactForm = ({ onSubmit }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [country, setCountry] = useState([]);
    const { apiGlobal } = React.useContext(AuthContext);
  
  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
  
      input.onChange(file);
    } else {
      setSelectedImage(null);
      input.onChange(null);
    }
  };

  const fetchCountryList = async () => {
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } 
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

  return (
    <Col md={12} lg={12}>
      <Form onSubmit={onSubmit}>
        {({ handleSubmit, form }) => (
          <FormContainer onSubmit={handleSubmit}>
            {/* Primary Contact Details Section */}
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle />
                  <p><span style={{ color: 'red' }}>*{' '}</span>Marks Fields are Required</p>
                </CardTitleWrap>
                {/* First Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="userName"
                          component="input"
                          type="text"
                          placeholder="Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Phone Number<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="countryCode"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                          )}
                              </div>
                                                    )}
                          />
                        
                          {/* Phone Input */}
                          <Field
                            name="userPhone"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                  // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  borderRadius: '5px',
                                  border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                      )}
                              </div>
                                                    )}
                            // validate={value => 
                            // (value && value.length === 12 ? undefined : '12 digit phone required')}
                          />
                        </div>

                        {/* <Field name="countryCode">
                          {({ input, meta }) => (
                            <div>
                              <select
                                {...input}
                                style={{
                              height: '45px',
                              backgroundColor: 'white',
                              border: '1px solid gray',
                              width: '100%',
                              borderRadius: '5px',
                              paddingLeft: '10px',
                            }}
                                required
                              >
                                <option value="">Select Country Code</option>
                                {country.map(nation => (
                                  <option key={nation.id} value={nation.id}>
                                    {nation.country_code}
                                  </option>
                                                      ))}
                              </select>
                              {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                    )}
                            </div>
                                                  )}
                        </Field>
                        <Field
                          name="userPhone"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          pattern="\d{1,15}"
                          maxLength={15} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          // type="text"
                          placeholder="Phone Number"
                          required
                          style={{ height: '45px' }}
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Second Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="userEmail"
                          component="input"
                          type="email"
                          placeholder="Email"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>UINs #<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uin"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={15} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 15);
                          }}
                          placeholder="UIN"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    
                  </Col>
                  
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Logo<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="file"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handleFileChange(e, input)}
                              required
                              style={{ height: '45px' }}
                            />
                          )}
                          
                        />
                      </FormGroupField>
                    </FormGroup>

                    {selectedImage && (
                      <FormGroup>
                        <FormGroupLabel>Selected Logo</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedImage}
                            alt="Selected Logo"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                            required
                          />
                        </FormGroupField>
                      </FormGroup>
                    )}  
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              // isLoading={isLoading}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Account Details Section */}
            <Card>
              <CardBody>
                <CardTitleWrap>
                  <CardTitle>Account Details</CardTitle>
                </CardTitleWrap>
                {/* Third Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accName"
                          component="input"
                          type="text"
                          placeholder="Account Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        {/* <Field
                          name="accCountry"
                          component="input"
                          type="text"
                          placeholder="Country"
                          required
                        /> */}
                        <Field
                          name="accCountry"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="accCountry"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              // isLoading={isLoading}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a account country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Fourth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Account<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accountNo"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={12} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="Account No"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="accCity"
                          component="input"
                          type="text"
                          placeholder="City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Fifth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Confirm Account<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="conAccount"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={12} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="Re-enter account no"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Branch<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="branch"
                          component="input"
                          type="text"
                          placeholder="Branch"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Sixth Row: 2 columns */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>IFSC<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="ifscCode"
                          component="input"
                          type="text"
                          placeholder="IFSC"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormGroupLabel>Bank<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="bank"
                          component="input"
                          type="text"
                          placeholder="Bank"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <FormButtonToolbar style={{ float: 'right' }}>
              <Button variant="primary" type="submit">Submit</Button>
            </FormButtonToolbar>
          </FormContainer>
      )}
      </Form>
    </Col>
);
};

PrimaryContactForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default PrimaryContactForm;
